import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "navbar navbar-expand-lg fixed-top navbar-dark bg-dark",
  style: {"margin-bottom":"0"}
}
const _hoisted_2 = { class: "navbar-brand" }
const _hoisted_3 = {
  class: "collapse navbar-collapse",
  id: "navBar"
}
const _hoisted_4 = { class: "navbar-nav mr-auto" }
const _hoisted_5 = { class: "nav-item dropdown" }
const _hoisted_6 = { class: "dropdown-menu" }
const _hoisted_7 = { class: "dropdown-item" }
const _hoisted_8 = { class: "dropdown-item" }
const _hoisted_9 = { class: "dropdown-item" }
const _hoisted_10 = { class: "dropdown-item" }
const _hoisted_11 = { class: "dropdown-item" }
const _hoisted_12 = { class: "nav-item dropdown" }
const _hoisted_13 = { class: "dropdown-menu" }
const _hoisted_14 = { class: "dropdown-item" }
const _hoisted_15 = { class: "dropdown-item" }
const _hoisted_16 = { class: "dropdown-item" }
const _hoisted_17 = { class: "dropdown-item" }
const _hoisted_18 = { class: "dropdown-item" }
const _hoisted_19 = { class: "dropdown-item" }
const _hoisted_20 = { class: "dropdown-item" }
const _hoisted_21 = { class: "nav-item" }
const _hoisted_22 = { class: "nav-link" }
const _hoisted_23 = { class: "nav-item" }
const _hoisted_24 = { class: "nav-link" }
const _hoisted_25 = { class: "nav-item" }
const _hoisted_26 = { class: "nav-link" }
const _hoisted_27 = { class: "nav-item dropdown" }
const _hoisted_28 = { class: "dropdown-menu" }
const _hoisted_29 = { class: "dropdown-item" }
const _hoisted_30 = { class: "dropdown-item" }
const _hoisted_31 = { class: "navbar-nav" }
const _hoisted_32 = { class: "nav-item dropdown" }
const _hoisted_33 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_34 = { class: "dropdown-item" }


export default /*@__PURE__*/_defineComponent({
  __name: 'PortfolioNavigation',
  props: {
    workspaceId: {},
    projectId: {}
  },
  setup(__props: any) {

    // ---------------- props ----------------

    

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_2, [...(_cache[0] || (_cache[0] = [
      _createTextVNode("Kanban", -1 /* CACHED */)
    ]))])), [
      [_directive_sanitizedHref, `/#/portfolio/kanban/${__props.workspaceId}/${__props.projectId}`]
    ]),
    _cache[30] || (_cache[30] = _createElementVNode("button", {
      class: "navbar-toggler",
      type: "button",
      "data-toggle": "collapse",
      "data-target": "#navBar",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }, [
      _createElementVNode("span", { class: "navbar-toggler-icon" })
    ], -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", _hoisted_5, [
          _cache[7] || (_cache[7] = _createElementVNode("a", {
            class: "nav-link dropdown-toggle",
            "data-toggle": "dropdown"
          }, " Projects ", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_7, [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Proposals", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/portfolio/projects-proposals/${__props.workspaceId}/${__props.projectId}`]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_8, [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Scheduled", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/portfolio/projects-scheduled/${__props.workspaceId}/${__props.projectId}`]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_9, [...(_cache[3] || (_cache[3] = [
              _createTextVNode("Started", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/portfolio/projects-started/${__props.workspaceId}/${__props.projectId}`]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_10, [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Finished", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/portfolio/projects-finished/${__props.workspaceId}/${__props.projectId}`]
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_11, [...(_cache[5] || (_cache[5] = [
              _createTextVNode("All", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/portfolio/projects-all/${__props.workspaceId}/${__props.projectId}`]
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_12, [
          _cache[17] || (_cache[17] = _createElementVNode("a", {
            class: "nav-link dropdown-toggle",
            "data-toggle": "dropdown"
          }, " Manage ", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_13, [
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_14, [...(_cache[8] || (_cache[8] = [
              _createTextVNode("Attributes", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/portfolio/attributes/${__props.workspaceId}/${__props.projectId}`]
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_15, [...(_cache[9] || (_cache[9] = [
              _createTextVNode("Forms", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/portfolio/forms/${__props.workspaceId}/${__props.projectId}`]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_16, [...(_cache[10] || (_cache[10] = [
              _createTextVNode("Lists", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/portfolio/lists-manager/${__props.workspaceId}/${__props.projectId}`]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_17, [...(_cache[11] || (_cache[11] = [
              _createTextVNode("Notifications", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/portfolio/notifications/${__props.workspaceId}/${__props.projectId}`]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_18, [...(_cache[12] || (_cache[12] = [
              _createTextVNode("Dependencies", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/portfolio/dependencies/${__props.workspaceId}/${__props.projectId}`]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_19, [...(_cache[13] || (_cache[13] = [
              _createTextVNode("Request pages", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/portfolio/pages/${__props.workspaceId}/${__props.projectId}`]
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_20, [...(_cache[14] || (_cache[14] = [
              _createTextVNode("People", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/portfolio/people/${__props.workspaceId}/${__props.projectId}`]
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_21, [
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_22, [...(_cache[18] || (_cache[18] = [
            _createTextVNode("Evaluation", -1 /* CACHED */)
          ]))])), [
            [_directive_sanitizedHref, `/#/portfolio/goals/${__props.workspaceId}/${__props.projectId}`]
          ])
        ]),
        _createElementVNode("li", _hoisted_23, [
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_24, [...(_cache[19] || (_cache[19] = [
            _createTextVNode("Assessments", -1 /* CACHED */)
          ]))])), [
            [_directive_sanitizedHref, `/#/portfolio/assessments/${__props.workspaceId}/${__props.projectId}`]
          ])
        ]),
        _createElementVNode("li", _hoisted_25, [
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_26, [...(_cache[20] || (_cache[20] = [
            _createTextVNode("Planning", -1 /* CACHED */)
          ]))])), [
            [_directive_sanitizedHref, `/#/portfolio/plans/${__props.workspaceId}/${__props.projectId}`]
          ])
        ]),
        _createElementVNode("li", _hoisted_27, [
          _cache[23] || (_cache[23] = _createElementVNode("a", {
            class: "nav-link dropdown-toggle",
            "data-toggle": "dropdown"
          }, " Reporting ", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_28, [
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_29, [...(_cache[21] || (_cache[21] = [
              _createTextVNode("Reports", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/portfolio/reports/${__props.workspaceId}/${__props.projectId}`]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_30, [...(_cache[22] || (_cache[22] = [
              _createTextVNode("P&L", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/portfolio/pnl/${__props.workspaceId}/${__props.projectId}`]
            ])
          ])
        ])
      ]),
      _createElementVNode("ul", _hoisted_31, [
        _createElementVNode("li", _hoisted_32, [
          _cache[29] || (_cache[29] = _createElementVNode("a", {
            class: "nav-link dropdown-toggle",
            "data-toggle": "dropdown"
          }, " Account ", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_33, [
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_34, [...(_cache[24] || (_cache[24] = [
              _createTextVNode("Back to workspace", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, `/#/projects/${__props.workspaceId}`]
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("a", {
              class: "dropdown-item",
              href: "/#/organizations/users/dashboard"
            }, "My dashboard", -1 /* CACHED */)),
            _cache[26] || (_cache[26] = _createElementVNode("a", {
              class: "dropdown-item",
              href: "/#/organizations/users/account"
            }, "Manage your account", -1 /* CACHED */)),
            _cache[27] || (_cache[27] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
            _cache[28] || (_cache[28] = _createElementVNode("a", {
              class: "dropdown-item",
              href: "/organizations/sessions/close"
            }, "Sign out", -1 /* CACHED */))
          ])
        ])
      ])
    ])
  ]))
}
}

})